import React from "react"

import { motion } from "framer-motion"
import { useInView } from 'react-intersection-observer';

import './Download.css'

import app_store from './../../utils/img/appStoreBadgeUsBlack.svg'
import google_play from './../../utils/img/googlePlayBadgeUs.svg'


const Download = ({ appStore, googlePlay, qrImage}) => {

    const appearQr = {
        start: {
            opacity: 0,
            scale: .6
        },
        end: { 
            opacity: 1,
            scale: 1,
            transition: {
                duration: .6
            }
        }
    }

    const [animationDownload, inViewQr] = useInView({
        triggerOnce: true,
        threshold: .9
    });

    return (        
        <section className={`download-wrapper`} >
        <a name={`downloadSection`}></a>
            <div className={`download`}>
                <div className={`download-inner`}>
                    <p className={`title _title-big bold `}>
                        Scarica l'applicazione
                    </p>

                    <motion.div className={`download-inner-qrbox`} ref={animationDownload} initial={`start`} animate={inViewQr ? `end` : `start`} variants={appearQr}>
                        <img src={qrImage} width={`100`}/>
                        <p className={`_text-small italic`}>Inquadra il qrcode con la fotocamera del tuo device per scaricare l’applicazione</p>
                    </motion.div>

                    <ul className={`store-buttons`}>
                        <li><a href={appStore}><img src={app_store} alt={`App Store`} /></a></li>
                        <li><a href={googlePlay}><img src={google_play} alt={` Google Play`} /></a></li>
                    </ul>
                </div>
            </div>
        </section>
    )
}

export default Download